import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { DataSet, Network } from "vis-network/standalone";
import NetworkNodeModal from "../../HighCharts/NetworkNodeModal";
import isEqual from "react-fast-compare";
import "./NetworkGraphV2.scss";
import { Button, Popover, Tooltip } from "antd";
// import ArrowDown from "../../../../../assets/NetworkGraph/Arrow_Down.svg";
// import ArrowLeft from "../../../../../assets/NetworkGraph/Arrow_Left.svg";
// import ArrowRight from "../../../../../assets/NetworkGraph/Arrow_Right.svg";
// import Arrow_Up from "../../../../../assets/NetworkGraph/Arrow_Up.svg";
// import Image from "antd/lib/image";
// import fullScreen from "../../../../../assets/NetworkGraph/Screen_Full.png";
import ArrowDown from "../../../../../assets/NetworkGraph/Navigation/NavigationDownWhiteBackground.svg";
import ArrowDownDark from "../../../../../assets/NetworkGraph/Navigation/NavigationDownDarkBackground.svg";
import ArrowLeft from "../../../../../assets/NetworkGraph/Navigation/NavigationLeftWhiteBackground.svg";
import ArrowLeftDark from "../../../../../assets/NetworkGraph/Navigation/NavigationLeftDarkBackground.svg";
import ArrowRight from "../../../../../assets/NetworkGraph/Navigation/NavigationRightWhiteBackground.svg";
import ArrowRightDark from "../../../../../assets/NetworkGraph/Navigation/NavigationRightDarkBackground.svg";
import ArrowUp from "../../../../../assets/NetworkGraph/Navigation/NavigationUpWhiteBackground.svg";
import ArrowUpDark from "../../../../../assets/NetworkGraph/Navigation/NavigationUpDarkBackground.svg";
import FullScreen from "../../../../../assets/NetworkGraph/Navigation/FullScreenDarkBackground.svg";
import FullScreenDark from "../../../../../assets/NetworkGraph/Navigation/FullScreenDarkBackground.svg";
import ZoomIn from "../../../../../assets/NetworkGraph/Navigation/ZoomInWhiteBackground.svg";
import ZoomInDark from "../../../../../assets/NetworkGraph/Navigation/ZoomInDarkBackground.svg";
import ZoomOut from "../../../../../assets/NetworkGraph/Navigation/ZoomOutWhiteBackground.svg";
import ZoomOutDark from "../../../../../assets/NetworkGraph/Navigation/ZoomOutDarkBackground.svg";
import ResetZoom from "../../../../../assets/NetworkGraph/Navigation/ResetZoomWhiteBackground.svg";
import ResetZoomDark from "../../../../../assets/NetworkGraph/Navigation/ResetZoomDarkBackground.svg";
import RefershIcon from "../../../../../assets/NetworkGraph/Navigation/RefreshZoomWhiteBackground.svg";
import RefershIconDark from "../../../../../assets/NetworkGraph/Navigation/RefreshZoomDarkBackground.svg";

import HideNodes from "../../../../../assets/NetworkGraph/Navigation/HideNodesWhiteBackground.svg";
import HideNodesDark from "../../../../../assets/NetworkGraph/Navigation/HideNodesDarkBackground.svg";
import UnhideNodes from "../../../../../assets/NetworkGraph/Navigation/UnhideNodesWhiteBackground.svg";
import UnhideNodesDark from "../../../../../assets/NetworkGraph/Navigation/UnhideNodesDarkBackground.svg";

import HideMultilne from "../../../../../assets/NetworkGraph/Navigation/HideMultileLineWhiteBackground.svg";
import HideMultilneDark from "../../../../../assets/NetworkGraph/Navigation/HideMultileLineDarkBackground.svg";
import UnhideMultilne from "../../../../../assets/NetworkGraph/Navigation/UnhideMultileLineWhiteBackground.svg";
import UnhideMultilneDark from "../../../../../assets/NetworkGraph/Navigation/UnhideMultileLineDarkBackground.svg";

import HideDistinctNodes from "../../../../../assets/NetworkGraph/Navigation/HideDistinctNodesWhiteBackground.svg";
import HideDistinctNodesDark from "../../../../../assets/NetworkGraph/Navigation/HideDistinctNodesDarkBackground.svg";
import UnhideDistinctNodes from "../../../../../assets/NetworkGraph/Navigation/UnhideDistinctNodesWhiteBackground.svg";
import UnhideDistinctNodesDark from "../../../../../assets/NetworkGraph/Navigation/UnhideDistinctNodesDarkBackground.svg";

import SeetingIconWhite from "../../../../../assets/NetworkGraph/SettingIconWhite.svg";
import SeetingIconDark from "../../../../../assets/NetworkGraph/SettingIconDark.svg";

import GenerateStatus from "./GenerateStatus";
import NetworkNodeTooltip from "./NetworkNodeTooltip";
import NetworkDeepdive from "./NetworkDeepdive";
import { useSelector } from "react-redux";
import {
  BASE_FONT_SIZE,
  DISABLE_NODE_AND_EDGES_COLOR,
  MAX_NODE_SIZE,
  MIN_NODE_SIZE,
  MIN_WIDTH_OF_EDGE,
  NEXT_DATA_LOAD_INTERVAL,
  NEXT_DATA_SET,
  SCALE_FACTOR_FOR_FONT_SIZE,
  SCALE_FACTOR_OF_EDGE_WIDTH,
  ZOOM_LEVEL_FOR_IMAGE,
} from "../../../../../redux/constants/networkEnums";
import {
  callNotification,
  hexToGrayscale,
  newColorShadeInHex6,
} from "../../../../../redux/constants";
import useDebounce from "../../../../layout/WelcomePage/Worksheets/useDebounce";
import { getNetworkIcon } from "./NetworkDynamicIcon";
const NetworkClusterV2 = ({
  nodes,
  edges,
  options,
  id,
  style,
  single,
  section_index,
  widget_index,
  metadata,
  PdfDownloadStatus,
  type,
  isNetworkDeepDive,
  clustersData,
  chartGradientColor,
  hideSetting,
  onSettingChange,
  dashboard,
}) => {
  const containerRef = useRef(null);
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const commonEdgesColor = useSelector(
    (state) => state?.Network?.networkCommonEdgesColor
  );
  const edgesHighlightColor = useSelector(
    (state) => state?.Network?.networkEdgesHighlightColor
  );
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const legendDivRef = useRef(null);
  const [refLegendUpdated, setRefLegendUpdated] = useState(false);

  // callback function got called when reference of legend is loaded
  const measuredLegendRef = useCallback((node) => {
    if (node !== null) {
      legendDivRef.current = node;
      setRefLegendUpdated(!refLegendUpdated);
    }
  }, []);

  const [dataProcessing, setDataProcessing] = useState(true);
  const [processNextDataLoad, setProcessNextDataLoad] = useState(false);
  const [postCardDetails, setPostCardDetails] = useState(null);
  const [networkDeepDiveObj, setNetworkDeepDiveObj] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [screenLoader, setScreenLoader] = useState(true);
  const [network, setNetwork] = useState(null);
  const [renderedNodes, setRenderedNodes] = useState([]);
  const [renderedEdges, setRenderedEdges] = useState([]);
  const [renderedCluster, setRenderedCluster] = useState({
    index: 0,
    renderedNodesLength: 0,
    renderedEdgesLength: 0,
  });
  const [
    stabilizeNetworkAfterAllNodesRenders,
    setStabilizeNetworkAfterAllNodesRenders,
  ] = useState(false);
  const [waitForInitialRender, setWaitForInitialRender] = useState(true);
  const [showHideNodeImage, setShowHideNodeImage] = useState(false);
  const [showHideCommonEdges, setShowHideCommonEdges] = useState(false);
  const [showHideDistinctNodeEdges, setShowHideDistinctNodeEdges] =
    useState(false);
  const [showHideMultipleEdges, setShowHideMultipleEdges] = useState(false);
  const [addDataInIntervalHandler, setAddDataInIntervalHandler] = useState();
  const [tooltipObject, setTooltipObject] = useState(null);
  const [movementInterval, setMovementInterval] = useState(null);
  const [direction, setDirection] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  const [settingPopoverOpen, setSettingPopoverOpen] = useState(false);
  const [settingAppliedStatus, setSettingAppliedStatus] = useState(false);
  const [minimumYAxesNodesLimit, setMinimumYAxesNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 1 : 1
  );
  const [maximumYAxesNodesLimit, setMaximumYAxesNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 100 : 100
  );

  const [axisSettingData, setAxisSettingData] = useState(null);
  const debouncedAxisSettingData = useDebounce(axisSettingData, 500);

  const [axisNodeLimitData, setAxisNodeLimitData] = useState(null);
  const [previousAxisSettingData, setPreviousAxisSettingData] = useState(null);
  const debouncedAxisNodeLimitData = useDebounce(axisNodeLimitData, 100);

  useEffect(() => {
    if (metadata && !axisSettingData) {
      let updatedAxisSettingData = structuredClone(axisSettingData);
      // if (metadata?.x_axis) {
      //   updatedAxisSettingData = updatedAxisSettingData
      //     ? {
      //         ...updatedAxisSettingData,
      //         ["x_axis"]: { ...metadata?.x_axis },
      //       }
      //     : { ["x_axis"]: { ...metadata?.x_axis } };
      // }
      if (metadata?.y_axes) {
        updatedAxisSettingData = updatedAxisSettingData
          ? {
              ...updatedAxisSettingData,
              ["y_axes"]: [...metadata?.y_axes],
            }
          : { ["y_axes"]: [...metadata?.y_axes] };
      }
      // if (metadata?.y_series) {
      //   updatedAxisSettingData = updatedAxisSettingData
      //     ? {
      //         ...updatedAxisSettingData,
      //         ["y_series"]: [...metadata?.y_series],
      //       }
      //     : { ["y_series"]: [...metadata?.y_series] };
      // }
      // // for common and highlight color
      // if (commonEdgesColor) {
      //   updatedAxisSettingData.commonEdgesColor = commonEdgesColor;
      // }
      // if (edgesHighlightColor) {
      //   updatedAxisSettingData.edgesHighlightColor = edgesHighlightColor;
      // }
      setAxisSettingData(updatedAxisSettingData);
      setAxisNodeLimitData(updatedAxisSettingData);
      setPreviousAxisSettingData(updatedAxisSettingData);
      setSettingAppliedStatus(false);
    }
  }, [metadata, settingPopoverOpen]);

  const handleChangeNodeLimit = (value, axis, nodeIndex) => {
    setSettingAppliedStatus(false);
    if (
      !axisNodeLimitData ||
      (axisNodeLimitData &&
        axisNodeLimitData?.[axis]?.x_limit !== parseInt(value, 10))
    ) {
      let updatedAxisNodeLimitData = axisNodeLimitData;
      updatedAxisNodeLimitData.currentAxis = axis;
      updatedAxisNodeLimitData.currentNodeIndex = nodeIndex;
      // if (axis === "x_axis") {
      //   updatedAxisNodeLimitData = axisNodeLimitData
      //     ? {
      //         ...axisNodeLimitData,
      //         [axis]: {
      //           ...axisNodeLimitData?.[axis],
      //           x_limit: parseInt(value, 10),
      //         },
      //       }
      //     : { [axis]: { x_limit: parseInt(value, 10) } };
      // }
      if (axis === "y_axes") {
        let updateYAxes = [];
        if (
          nodeIndex >= 0 &&
          axisNodeLimitData?.[axis] &&
          Array.isArray(axisNodeLimitData?.[axis])
        ) {
          updateYAxes = structuredClone(axisNodeLimitData?.[axis]);
          updateYAxes = updateYAxes?.map((y, i) => {
            if (i === nodeIndex) {
              y.y_limit = parseInt(value, 10);
            }
            return y;
          });
        }
        updatedAxisNodeLimitData = axisNodeLimitData
          ? {
              ...axisNodeLimitData,
              [axis]:
                updateYAxes?.length > 0
                  ? [...updateYAxes]
                  : [...axisNodeLimitData?.[axis]],
            }
          : { [axis]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
      }
      setAxisNodeLimitData(updatedAxisNodeLimitData);
    }
  };
  useEffect(() => {
    if (debouncedAxisNodeLimitData?.currentAxis) {
      if (debouncedAxisNodeLimitData?.currentAxis === "y_axes") {
        let yLimitChanged = false;
        let axis = debouncedAxisNodeLimitData?.currentAxis;
        let nodeIndex = debouncedAxisNodeLimitData?.currentNodeIndex;
        let updatedAxisSettingData = axisSettingData;
        let updateYAxes = [];
        if (
          nodeIndex >= 0 &&
          axisSettingData?.[axis] &&
          Array.isArray(axisSettingData?.[axis])
        ) {
          updateYAxes = structuredClone(axisSettingData?.[axis]);
          updateYAxes = updateYAxes?.map((y, i) => {
            if (
              i === nodeIndex &&
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit >=
                minimumYAxesNodesLimit &&
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit <=
                maximumYAxesNodesLimit
            ) {
              yLimitChanged = true;
              y.y_limit = parseInt(
                debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit,
                10
              );
            }
            return y;
          });
        }
        updatedAxisSettingData = axisSettingData
          ? {
              ...axisSettingData,
              [axis]:
                updateYAxes?.length > 0
                  ? [...updateYAxes]
                  : [...axisSettingData?.[axis]],
            }
          : { [axis]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
        if (yLimitChanged) setAxisSettingData(updatedAxisSettingData);
      }
    }
  }, [debouncedAxisNodeLimitData]);

  useEffect(() => {
    if (debouncedAxisSettingData) {
      let yAxesIsUpdated = false;
      let yAxesIsValid = true;
      if (
        Array.isArray(debouncedAxisSettingData?.y_axes) &&
        Array.isArray(previousAxisSettingData?.y_axes)
      ) {
        for (let i = 0; i < debouncedAxisSettingData?.y_axes?.length; i++) {
          let yAxesCurrentObj = debouncedAxisSettingData?.y_axes?.[i];
          for (let j = 0; j < previousAxisSettingData?.y_axes?.length; j++) {
            let yAxesPreviousObj = previousAxisSettingData?.y_axes?.[i];
            if (
              !(
                debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit >=
                  minimumYAxesNodesLimit &&
                debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit <=
                  maximumYAxesNodesLimit
              )
            ) {
              yAxesIsValid = false;
            }
            if (!isEqual(yAxesCurrentObj, yAxesPreviousObj)) {
              yAxesIsUpdated = true;
              if (!yAxesIsValid) break;
            }
            if (yAxesIsUpdated && !yAxesIsValid) break;
          }
        }
      }
      if (yAxesIsUpdated && yAxesIsValid) {
        setSettingAppliedStatus(true);
      } else {
        setSettingAppliedStatus(false);
      }
    }
  }, [debouncedAxisSettingData]);
  const handleSettingApplied = () => {
    let yAxesIsUpdated = false;
    let yAxesIsValid = true;
    if (
      Array.isArray(debouncedAxisSettingData?.y_axes) &&
      Array.isArray(previousAxisSettingData?.y_axes)
    ) {
      for (let i = 0; i < debouncedAxisSettingData?.y_axes?.length; i++) {
        let yAxesCurrentObj = debouncedAxisSettingData?.y_axes?.[i];
        for (let j = 0; j < previousAxisSettingData?.y_axes?.length; j++) {
          let yAxesPreviousObj = previousAxisSettingData?.y_axes?.[i];
          if (!isEqual(yAxesCurrentObj, yAxesPreviousObj)) {
            if (
              !(
                debouncedAxisSettingData?.y_axes?.[i]?.y_limit >=
                  minimumYAxesNodesLimit &&
                debouncedAxisSettingData?.y_axes?.[i]?.y_limit <=
                  maximumYAxesNodesLimit
              )
            ) {
              yAxesIsValid = false;
            }
            yAxesIsUpdated = true;
            if (!yAxesIsValid) break;
          }
          if (yAxesIsUpdated && !yAxesIsValid) break;
        }
      }
    }
    if (yAxesIsUpdated && yAxesIsValid) {
      let updatedPropListOfWidget = [];
      let yAxesPropValue;
      if (
        yAxesIsUpdated &&
        debouncedAxisSettingData?.["y_axes"] &&
        Array.isArray(debouncedAxisSettingData?.["y_axes"])
      ) {
        yAxesPropValue = [...debouncedAxisSettingData?.["y_axes"]];
        updatedPropListOfWidget?.push({
          prop_name: "y_axes",
          prop_value: yAxesPropValue,
        });
      }
      setPreviousAxisSettingData(debouncedAxisSettingData);
      if (
        onSettingChange &&
        typeof onSettingChange === "function" &&
        updatedPropListOfWidget?.length > 0
      ) {
        onSettingChange(updatedPropListOfWidget);
      }
      setSettingAppliedStatus(false);
    } else {
      callNotification("Enter valid values", "alert");
    }
  };
  const removeDuplicateNodes = (nodes) => {
    const nodeMap = new Map();
    if (nodes && Array.isArray(nodes)) {
      nodes?.forEach((node) => {
        if (!nodeMap.has(node?.id)) {
          nodeMap.set(node?.id, node);
        }
      });
    }

    return Array.from(nodeMap?.values());
  };
  const removeDuplicateEdges = (edges) => {
    const edgeMap = new Map();
    if (edges && Array.isArray(edges)) {
      edges?.forEach((edge) => {
        if (!edgeMap.has(edge?.id)) {
          edgeMap.set(edge?.id, edge);
        }
      });
    }

    return Array.from(edgeMap?.values());
  };
  const calculateFontSize = (width) => {
    const baseFontSize = BASE_FONT_SIZE; // Base font size for minimum edge width
    const scaleFactor = SCALE_FACTOR_FOR_FONT_SIZE; // Scale factor to adjust font size with edge width
    return baseFontSize + width * scaleFactor;
  };
  const getNodeOfNetwork = (seriesData, nodeId) => {
    let node;
    let splittedValue = nodeId?.split("$N$");
    if (seriesData && Array.isArray(seriesData)) {
      for (
        let series_index = 0;
        series_index < seriesData?.length;
        series_index++
      ) {
        let series = seriesData?.[series_index];
        if (
          splittedValue?.[0] === id &&
          (splittedValue?.[1] === series?.cluster_id ||
            parseInt(splittedValue?.[1]) === series_index)
        ) {
          if (series?.nodes?.[splittedValue?.[2]]) {
            node = series?.nodes?.[splittedValue?.[2]];
            break;
          }
        }
      }
    } else if (seriesData && seriesData?.nodes) {
      if (seriesData?.nodes?.[splittedValue?.[2]]) {
        node = seriesData?.nodes?.[splittedValue?.[2]];
      }
    }
    return {
      ...node,
      ChannelGroupId: node?.ChannelGroupID
        ? node?.ChannelGroupID
        : node?.ChannelGroupId,
      ProfilePicture: node?.ProfilePicture
        ? node?.ProfilePicture
        : node?.ProfilePic,
    };
  };

  const getNodeDataForRendering = (rNodes) => {
    let updatedNodes = [];
    let connectedNodes = [];
    let zoomLevel = 0;
    if (selectedNode && typeof network?.getConnectedNodes === "function") {
      try {
        connectedNodes = network.getConnectedNodes(selectedNode);
      } catch (error) {
        connectedNodes = [];
      }
    }
    if (
      network &&
      network?.getScale &&
      typeof network?.getScale === "function"
    ) {
      try {
        zoomLevel = parseFloat(network?.getScale())?.toFixed(1);
      } catch (error) {
        zoomLevel = 0;
        console.error("Error : ", error);
      }
    }
    let showHideImage = showHideNodeImage || zoomLevel >= ZOOM_LEVEL_FOR_IMAGE;
    if (showHideImage) {
      const originalNodes = Array.isArray(rNodes) ? rNodes : [];
      updatedNodes = Array.isArray(originalNodes)
        ? originalNodes?.map((n) => {
            let updatedNodeObj = { ...n };
            let darkerColor =
              n?.nodeDataColor &&
              connectedNodes?.length > 0 &&
              !connectedNodes?.includes(n?.id)
                ? DISABLE_NODE_AND_EDGES_COLOR //hexToGrayscale(n?.nodeDataColor)
                : n?.nodeDataColor;
            let lighterColor = newColorShadeInHex6(darkerColor, 60);

            // here calculate darker text color for showing in tooltip
            let darkerTextColor = newColorShadeInHex6(darkerColor, -80);
            return {
              ...n,
              image: n?.image ? n?.image : undefined,
              label: n?.name ? n?.name : undefined,
              shape: n?.image ? "circularImage" : "dot",
              size: n?.image
                ? n?.size > MAX_NODE_SIZE
                  ? MAX_NODE_SIZE
                  : n?.size < MIN_NODE_SIZE
                  ? MIN_NODE_SIZE
                  : parseInt(n?.size)
                : MIN_NODE_SIZE,

              hidden:
                showHideCommonEdges && n?.id?.includes("common_cluster")
                  ? // ||
                    // (showHideDistinctNodeEdges &&
                    //   !n?.id?.includes("common_cluster"))
                    true
                  : false,
              color: {
                ...n?.color,
                borderWidth: n?.image ? 0 : 2,
                border: darkerColor,
                background: chartGradientColor
                  ? {
                      radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7,
                      },
                      stops: [
                        [0, lighterColor],
                        [1, darkerColor], // darken
                      ],
                    }
                  : lighterColor,
              },
            };
          })
        : [];
    } else {
      const originalNodes = Array.isArray(rNodes) ? rNodes : [];
      updatedNodes = Array.isArray(originalNodes)
        ? originalNodes?.map((n) => {
            let updatedNodeObj = { ...n };
            let darkerColor =
              n?.nodeDataColor &&
              connectedNodes?.length > 0 &&
              !connectedNodes?.includes(n?.id)
                ? DISABLE_NODE_AND_EDGES_COLOR //hexToGrayscale(n?.nodeDataColor)
                : n?.nodeDataColor;
            let lighterColor = newColorShadeInHex6(darkerColor, 60);

            // here calculate darker text color for showing in tooltip
            let darkerTextColor = newColorShadeInHex6(darkerColor, -80);
            return {
              ...n,
              image: undefined,
              shape: "dot",
              size:
                n?.size > MAX_NODE_SIZE
                  ? MAX_NODE_SIZE
                  : n?.size < MIN_NODE_SIZE
                  ? MIN_NODE_SIZE
                  : parseInt(n?.size),
              hidden:
                showHideCommonEdges && n?.id?.includes("common_cluster")
                  ? // ||
                    // (showHideDistinctNodeEdges &&
                    //   !n?.id?.includes("common_cluster"))
                    true
                  : false,
              color: {
                ...n?.color,
                borderWidth: n?.image ? 0 : 2,
                border: darkerColor,
                background: chartGradientColor
                  ? {
                      radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7,
                      },
                      stops: [
                        [0, lighterColor],
                        [1, darkerColor], // darken
                      ],
                    }
                  : lighterColor,
              },
              label: undefined,
            };
          })
        : [];
    }
    const uniqueNodes =
      updatedNodes?.length > 0 ? removeDuplicateNodes(updatedNodes) : [];
    return uniqueNodes;
  };
  const getEdgesDataForRendering = (rEdges) => {
    let updatedEdges = [];
    let connectedEdges = [];
    let zoomLevel = 0;
    if (selectedNode && typeof network?.getConnectedEdges === "function") {
      try {
        connectedEdges = network.getConnectedEdges(selectedNode);
      } catch (error) {
        connectedEdges = [];
      }
    }
    if (
      network &&
      network?.getScale &&
      typeof network?.getScale === "function"
    ) {
      try {
        zoomLevel = parseFloat(network?.getScale())?.toFixed(1);
      } catch (error) {
        zoomLevel = 0;
        console.error("Error : ", error);
      }
    }
    let showHideLabel = showHideNodeImage || zoomLevel >= ZOOM_LEVEL_FOR_IMAGE;
    const originalEdges = Array.isArray(rEdges) ? rEdges : [];
    updatedEdges = Array.isArray(originalEdges)
      ? originalEdges?.map((e) => {
          let dataLinkColor =
            e?.edgeColor &&
            connectedEdges?.length > 0 &&
            !connectedEdges?.includes(e?.id)
              ? DISABLE_NODE_AND_EDGES_COLOR //hexToGrayscale(e?.edgeColor)
              : e?.to?.includes("common_cluster")
              ? commonEdgesColor
              : e?.edgeColor;
          let opacity =
            e?.edgeColor &&
            connectedEdges?.length > 0 &&
            !connectedEdges?.includes(e?.id)
              ? 0.5
              : 1;
          let darkerTextColor = newColorShadeInHex6(dataLinkColor, -80);
          let updatedEdge = {
            ...e,
            hidden:
              (showHideCommonEdges && e?.to?.includes("common_cluster")) ||
              (showHideMultipleEdges && e?.id?.includes("_mtline_"))
                ? // ||
                  // (showHideDistinctNodeEdges && !e?.to?.includes("common_cluster"))
                  true
                : false,
            color: {
              ...e?.color,
              inherit: false,
              color: dataLinkColor,
              highlight: edgesHighlightColor
                ? edgesHighlightColor
                : darkerTextColor,
              hover: edgesHighlightColor
                ? edgesHighlightColor
                : darkerTextColor,
              opacity: opacity,
            },
            width:
              showHideMultipleEdges && !e?.id?.includes("_mtline_")
                ? MIN_WIDTH_OF_EDGE +
                  e?.numberOfLines * SCALE_FACTOR_OF_EDGE_WIDTH
                : MIN_WIDTH_OF_EDGE,
            label:
              showHideLabel &&
              showHideMultipleEdges &&
              !e?.id?.includes("_mtline_")
                ? `${e?.numberOfLines}`
                : "",
            font:
              showHideLabel &&
              showHideMultipleEdges &&
              !e?.id?.includes("_mtline_")
                ? {
                    ...e?.font,
                    color: edgesHighlightColor ? edgesHighlightColor : "#fffff",
                    align: "middle",
                    size: calculateFontSize(
                      showHideMultipleEdges && !e?.id?.includes("_mtline_")
                        ? MIN_WIDTH_OF_EDGE +
                            e?.numberOfLines * SCALE_FACTOR_OF_EDGE_WIDTH
                        : MIN_WIDTH_OF_EDGE
                    ),
                  }
                : false,
          };
          return updatedEdge;
        })
      : [];
    const uniqueEdges =
      updatedEdges?.length > 0 ? removeDuplicateEdges(updatedEdges) : [];
    return uniqueEdges;
  };
  const getNodesAndEdgesDataForCommonRendering = (
    rNodes,
    rEdges,
    hideCommonNodeAndEdges,
    hideMultipleEdges,
    hideDistinctNodeEdges,
    selectedNode
  ) => {
    let updatedEdges = [];
    let updatedNodes = [];
    let connectedEdges = [];
    let connectedNodes = [];
    let zoomLevel = 0;
    if (
      network &&
      network?.getScale &&
      typeof network?.getScale === "function"
    ) {
      try {
        zoomLevel = parseFloat(network?.getScale())?.toFixed(1);
      } catch (error) {
        zoomLevel = 0;
        console.error("Error : ", error);
      }
    }
    let showHideImage = showHideNodeImage || zoomLevel >= ZOOM_LEVEL_FOR_IMAGE;

    if (
      selectedNode &&
      typeof network?.getConnectedNodes === "function" &&
      typeof network?.getConnectedEdges === "function"
    ) {
      try {
        connectedNodes = network.getConnectedNodes(selectedNode);
        connectedEdges = network.getConnectedEdges(selectedNode);
      } catch (error) {
        connectedNodes = [];
        connectedEdges = [];
      }
    }
    const originalNodes = Array.isArray(rNodes) ? rNodes : [];
    updatedNodes = Array.isArray(originalNodes)
      ? originalNodes?.map((n) => {
          let updatedNodeObj = { ...n };
          let darkerColor =
            n?.nodeDataColor &&
            connectedNodes?.length > 0 &&
            !connectedNodes?.includes(n?.id)
              ? DISABLE_NODE_AND_EDGES_COLOR //hexToGrayscale(n?.nodeDataColor)
              : n?.nodeDataColor;
          let lighterColor = newColorShadeInHex6(darkerColor, 60);

          // here calculate darker text color for showing in tooltip
          let darkerTextColor = newColorShadeInHex6(darkerColor, -80);

          if (showHideImage) {
            updatedNodeObj = {
              ...updatedNodeObj,
              image: n?.image ? n?.image : undefined,
              label: n?.name ? n?.name : undefined,
              shape: n?.image ? "circularImage" : "dot",
              size: n?.image
                ? n?.size > MAX_NODE_SIZE
                  ? MAX_NODE_SIZE
                  : n?.size < MIN_NODE_SIZE
                  ? MIN_NODE_SIZE
                  : parseInt(n?.size)
                : MIN_NODE_SIZE,
              color: {
                ...n?.color,
                borderWidth: n?.image ? 0 : 2,
                border: darkerColor,
                background: chartGradientColor
                  ? {
                      radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7,
                      },
                      stops: [
                        [0, lighterColor],
                        [1, darkerColor], // darken
                      ],
                    }
                  : lighterColor,
              },
            };
          } else {
            updatedNodeObj = {
              ...updatedNodeObj,
              image: undefined,
              label: undefined,
              shape: "dot",
              size:
                n?.size > MAX_NODE_SIZE
                  ? MAX_NODE_SIZE
                  : n?.size < MIN_NODE_SIZE
                  ? MIN_NODE_SIZE
                  : parseInt(n?.size),
              color: {
                ...n?.color,
                borderWidth: n?.image ? 0 : 2,
                border: darkerColor,
                background: chartGradientColor
                  ? {
                      radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7,
                      },
                      stops: [
                        [0, lighterColor],
                        [1, darkerColor], // darken
                      ],
                    }
                  : lighterColor,
              },
            };
          }

          return {
            ...updatedNodeObj,
            hidden:
              hideCommonNodeAndEdges && n?.id?.includes("common_cluster")
                ? // ||
                  // (hideDistinctNodeEdges && !n?.id?.includes("common_cluster"))
                  true
                : false,
          };
        })
      : [];

    const originalEdges = Array.isArray(rEdges) ? rEdges : [];
    updatedEdges = Array.isArray(originalEdges)
      ? originalEdges?.map((e) => {
          let dataLinkColor =
            e?.edgeColor &&
            connectedEdges?.length > 0 &&
            !connectedEdges?.includes(e?.id)
              ? DISABLE_NODE_AND_EDGES_COLOR //hexToGrayscale(e?.edgeColor)
              : e?.to?.includes("common_cluster")
              ? commonEdgesColor
              : e?.edgeColor;
          let opacity =
            e?.edgeColor &&
            connectedEdges?.length > 0 &&
            !connectedEdges?.includes(e?.id)
              ? 0.5
              : 1;
          let darkerTextColor = newColorShadeInHex6(dataLinkColor, -80);
          return {
            ...e,
            hidden:
              (hideCommonNodeAndEdges && e?.to?.includes("common_cluster")) ||
              (hideMultipleEdges && e?.id?.includes("_mtline_"))
                ? // ||
                  // (hideDistinctNodeEdges && !e?.to?.includes("common_cluster"))
                  true
                : false,
            color: {
              ...e?.color,
              inherit: false,
              color: dataLinkColor,
              highlight: edgesHighlightColor
                ? edgesHighlightColor
                : darkerTextColor,
              hover: edgesHighlightColor
                ? edgesHighlightColor
                : darkerTextColor,
              opacity: opacity,
            },
            width:
              hideMultipleEdges && !e?.id?.includes("_mtline_")
                ? MIN_WIDTH_OF_EDGE +
                  e?.numberOfLines * SCALE_FACTOR_OF_EDGE_WIDTH
                : MIN_WIDTH_OF_EDGE,
            label:
              showHideImage && hideMultipleEdges && !e?.id?.includes("_mtline_")
                ? `${e?.numberOfLines}`
                : "",
            font:
              showHideImage && hideMultipleEdges && !e?.id?.includes("_mtline_")
                ? {
                    ...e?.font,
                    color: edgesHighlightColor ? edgesHighlightColor : "#fffff",
                    align: "middle",
                    size: calculateFontSize(
                      hideMultipleEdges && !e?.id?.includes("_mtline_")
                        ? MIN_WIDTH_OF_EDGE +
                            e?.numberOfLines * SCALE_FACTOR_OF_EDGE_WIDTH
                        : MIN_WIDTH_OF_EDGE
                    ),
                  }
                : false,
          };
        })
      : [];
    const uniqueNodes =
      updatedNodes?.length > 0 ? removeDuplicateNodes(updatedNodes) : [];
    const uniqueEdges =
      updatedEdges?.length > 0 ? removeDuplicateEdges(updatedEdges) : [];
    return { uniqueNodes, uniqueEdges };
  };
  useEffect(() => {
    setRefLegendUpdated(!refLegendUpdated);
  }, [legendDivRef?.current?.clientHeight]);

  const isPersonalizationPreviewOpen = useMemo(() => {
    return personalizationSettingsObj?.isPersonalizationPreviewOpen
      ? true
      : false;
  }, [personalizationSettingsObj?.isPersonalizationPreviewOpen]);
  useEffect(() => {
    setNetwork(null);
    const container = document.getElementById(id);
    // console.log(
    //   "\n\n\nNetworkClusterV2 : ",
    //   "nodes : ",
    //   nodes,
    //   "edges : ",
    //   edges,
    //   "clustersData : ",
    //   clustersData
    // );
    if (!container) return;
    setNetwork(null);
    setProcessNextDataLoad(false);
    setWaitForInitialRender(true);
    setStabilizeNetworkAfterAllNodesRenders(false);
    setScreenLoader(true);
    setTooltipObject(null);
    setNetworkDeepDiveObj(null);

    // Initialize the network instance
    const network = new Network(container, { nodes: [], edges: [] }, options);
    setNetwork(network);

    // Set up event listeners
    // on init
    network?.on("initRedraw", function () {
      // do something like move some custom elements?
      setDataProcessing(true);
    });

    // Add event listener to show tooltip on hover
    network?.on("hoverNode", (params) => {
      const nodeId = params?.node;
      // setSelectedNode(nodeId);
      const node =
        nodes && Array.isArray(nodes) && nodes?.find((f) => f?.id === nodeId);
      if (node) {
        setTooltipObject({
          node: node,
          clientX: parseInt(params?.event?.clientX),
          clientY: parseInt(params?.event?.clientY),

          canvasX: parseInt(params?.pointer?.canvas?.x),
          canvasY: parseInt(params?.pointer?.canvas?.y),
          domX: parseInt(params?.pointer?.DOM?.x),
          domY: parseInt(params?.pointer?.DOM?.y),
        });
      }
    });

    // Add event listener to hide tooltip on mouseout

    network?.on("blurNode", () => {
      // console.log(
      //   "\n\n\n ****************** blurNode event got called : **************************\n\n\n"
      // );
      setTooltipObject(null);
      // setSelectedNode(null);
    });
    network?.on("deselectNode", () => {
      // console.log(
      //   "\n\n\n ****************** deselectNode event got called : **************************\n\n\n"
      // );
      setSelectedNode(null);
    });

    network?.on("stabilized", () => {
      // console.log(
      //   "\n\n\n ****************** stabilized event got called : **************************\n\n\n"
      // );
      setWaitForInitialRender(false);
      //   if (network && typeof network?.setOptions === "function") {
      //     network?.setOptions({ physics: false }); // Disable physics after stabilization
      //   }

      // network.setOptions({ physics: { enabled: false } });
      // if (
      //   renderedNodes?.length !== nodes?.length ||
      //   renderedEdges?.length !== edges?.length
      // ) {
      //   // setProcessNextDataLoad(true);
      // } else {
      //   console.log(
      //     "\n\n\n\n****************** All node rendered ************************",
      //     stabilizeNetworkAfterAllNodesRenders
      //   );
      // }
    });
    network?.on("afterDrawing", function (ctx) {
      setDataProcessing(false);
      setScreenLoader(false);
    });

    //
    network?.on("click", function (params) {
      if (params?.nodes?.length > 0) {
        const selectedNode = params?.nodes?.[0];
        setSelectedNode(selectedNode);
      }
    });
    network?.on("doubleClick", function (params) {
      if (isPersonalizationPreviewOpen) {
        callNotification(
          "Actions are not allowed while customizing",
          "info",
          40,
          "personalization-preview-notification personalization-preview-mask",
          true
        );
        return;
      }
      if (
        params?.nodes?.length > 0 &&
        !isNetworkDeepDive &&
        !networkDeepDiveObj
      ) {
        let nodeId = params?.nodes[0];
        const node = getNodeOfNetwork(single, nodeId);
        if (node) {
          setPostCardDetails(node);
          setNetworkDeepDiveObj(node);
        }
      }
    });
    network?.on("zoom", (params) => {
      const zoomLevel = parseFloat(params?.scale)?.toFixed(1);
      setShowHideNodeImage(zoomLevel >= ZOOM_LEVEL_FOR_IMAGE);
      // // Adjust level of detail based on zoom level
      // if (zoomLevel < 0.5) {
      //   // Show only important nodes and edges
      //   network.setOptions({ nodes: { level: 1 }, edges: { level: 1 } });
      // } else if (zoomLevel < 1.5) {
      //   // Show more detailed nodes and edges
      //   network.setOptions({ nodes: { level: 2 }, edges: { level: 2 } });
      // } else {
      //   // Show all details
      //   network.setOptions({ nodes: { level: 3 }, edges: { level: 3 } });
      // }
    });

    // Prepare and update the network data
    let updatedRenderedCluster = {
      index: 0,
      renderedNodesLength: 0,
      renderedEdgesLength: 0,
    };
    let updatedRenderedNodes = [],
      updatedRenderedEdges = [];
    if (
      clustersData &&
      Array.isArray(clustersData) &&
      clustersData?.length > 0
    ) {
      let cluster = clustersData?.[updatedRenderedCluster?.index];
      if (cluster?.nodes && Array.isArray(cluster?.nodes)) {
        if (cluster?.nodeLength > NEXT_DATA_SET) {
          updatedRenderedNodes = cluster?.nodes?.slice(0, NEXT_DATA_SET);
          updatedRenderedNodes = getNodeDataForRendering(updatedRenderedNodes);
          updatedRenderedNodes = new DataSet(updatedRenderedNodes);
          setRenderedNodes(updatedRenderedNodes);
        } else {
          updatedRenderedNodes = getNodeDataForRendering(cluster?.nodes);
          updatedRenderedNodes = new DataSet(updatedRenderedNodes);
          setRenderedNodes(updatedRenderedNodes);
        }
        updatedRenderedCluster = {
          ...updatedRenderedCluster,
          index: updatedRenderedCluster?.index,
          renderedNodesLength: updatedRenderedNodes?.length,
        };
      }
      if (cluster?.edges && Array.isArray(cluster?.edges)) {
        if (cluster?.edgesLinkLength > NEXT_DATA_SET) {
          updatedRenderedEdges = cluster?.edges?.slice(0, NEXT_DATA_SET);
          updatedRenderedEdges = getEdgesDataForRendering(updatedRenderedEdges);
          updatedRenderedEdges = new DataSet(updatedRenderedEdges);
          setRenderedEdges(updatedRenderedEdges);
        } else {
          updatedRenderedEdges = getEdgesDataForRendering(cluster?.edges);
          updatedRenderedEdges = new DataSet(updatedRenderedEdges);
          setRenderedEdges(updatedRenderedEdges);
        }
        updatedRenderedCluster = {
          ...updatedRenderedCluster,
          index: updatedRenderedCluster?.index,
          renderedEdgesLength: updatedRenderedEdges?.length,
        };
      }
      if (
        updatedRenderedCluster?.renderedNodesLength ===
          cluster?.nodes?.length &&
        updatedRenderedCluster?.renderedEdgesLength === cluster?.edges?.length
      ) {
        updatedRenderedCluster = {
          ...updatedRenderedCluster,
          index: updatedRenderedCluster?.index + 1,
          renderedNodesLength: 0,
          renderedEdgesLength: 0,
        };
      }

      setRenderedCluster({
        ...updatedRenderedCluster,
      });
      network?.setData({
        nodes: updatedRenderedNodes,
        edges: updatedRenderedEdges,
      });
    }

    // Clean up when component unmounts
    return () => {
      if (network) {
        network?.off("hoverNode");
        network?.off("blurNode");
        network?.off("deselectNode");
        network?.off("stabilized");
        network?.off("initRedraw");
        network?.off("afterDrawing");
        network?.off("click");
        network?.off("doubleClick");
        network?.off("zoom");
        network?.destroy();
      }
    };
  }, [nodes, edges, options, clustersData, isPersonalizationPreviewOpen]);
  const handleFullScreen = () => {
    const container = containerRef?.current;
    if (container?.requestFullscreen) {
      container?.requestFullscreen();
    } else if (container?.mozRequestFullScreen) {
      container?.mozRequestFullScreen();
    } else if (container?.webkitRequestFullscreen) {
      container?.webkitRequestFullscreen();
    } else if (container?.msRequestFullscreen) {
      container?.msRequestFullscreen();
    }
  };

  useEffect(() => {
    if (
      renderedNodes?.length === nodes?.length &&
      renderedEdges?.length === edges?.length &&
      !stabilizeNetworkAfterAllNodesRenders
    ) {
      setStabilizeNetworkAfterAllNodesRenders(true);
      // network && network?.stabilize();
    }
    if (
      renderedCluster?.index === clustersData?.length &&
      !stabilizeNetworkAfterAllNodesRenders
    ) {
      setStabilizeNetworkAfterAllNodesRenders(true);
      //   setRenderedCluster({
      //     index: 0,
      //     renderedNodesLength: 0,
      //     renderedEdgesLength: 0,
      //   });
    }
  }, [
    stabilizeNetworkAfterAllNodesRenders,
    renderedNodes?.length,
    renderedEdges?.length,
    renderedCluster?.index,
  ]);
  useEffect(() => {
    // console.log(
    //   "\n\n\n ******************* useEffect got called ********************* \n\n"
    // );
    // console.log("processNextDataLoad : ", processNextDataLoad);
    let nextDataProcessHandler;
    try {
      if (!waitForInitialRender) {
        nextDataProcessHandler = setTimeout(() => {
          if (processNextDataLoad) {
            loadMoreNetworkData();
          } else {
            setProcessNextDataLoad(true);
          }
        }, [processNextDataLoad ? 100 : NEXT_DATA_LOAD_INTERVAL]);
      }
    } catch (error) {
      console.error("Error getting on lazy load");
    }

    return () => clearTimeout(nextDataProcessHandler);
  }, [processNextDataLoad, waitForInitialRender]);
  useEffect(() => {
    // if it is true that means show images
    try {
      const rNodes =
        typeof renderedNodes?.get === "function" && renderedNodes?.get();
      const originalNodes = Array.isArray(rNodes)
        ? nodes?.slice(0, rNodes?.length)
        : [];
      let updatedNodes = getNodeDataForRendering(originalNodes);
      if (typeof renderedNodes?.update === "function") {
        renderedNodes?.update([...updatedNodes]);
        // network?.destroy();
        if (
          network &&
          network?.redraw &&
          typeof network?.redraw === "function"
        ) {
          network?.redraw();
        }
      }
    } catch (error) {
      console.error(
        "Getting error while updating nodes and edges in case of showHideNodeImage : ",
        error
      );
    }

    // if it is true that means hide the edges lable
    try {
      const rEdges =
        typeof renderedEdges?.get === "function" && renderedEdges?.get();
      const originalEdges = Array.isArray(rEdges)
        ? edges?.slice(0, rEdges?.length)
        : [];
      let updatedEdges = getEdgesDataForRendering(originalEdges);
      if (
        typeof renderedEdges?.update === "function" &&
        updatedEdges?.length > 0
      ) {
        renderedEdges?.update([...updatedEdges]);
        if (
          network &&
          network?.redraw &&
          typeof network?.redraw === "function"
        ) {
          network?.redraw();
        }
      }
    } catch (error) {
      console.error(
        "Getting error while updating edges label in case of zoom level : ",
        error
      );
    }
  }, [showHideNodeImage]);
  useEffect(() => {
    // if it is true that means hide common nodes and edges
    try {
      const rNodes =
        typeof renderedNodes?.get === "function" && renderedNodes?.get();
      const originalNodes = Array.isArray(rNodes)
        ? nodes?.slice(0, rNodes?.length)
        : [];
      const rEdges =
        typeof renderedEdges?.get === "function" && renderedEdges?.get();
      const originalEdges = Array.isArray(rEdges)
        ? edges?.slice(0, rEdges?.length)
        : [];
      let { uniqueNodes, uniqueEdges } = getNodesAndEdgesDataForCommonRendering(
        originalNodes,
        originalEdges,
        showHideCommonEdges,
        showHideMultipleEdges,
        showHideDistinctNodeEdges,
        selectedNode
      );
      if (
        typeof renderedNodes?.update === "function" &&
        uniqueNodes?.length > 0
      ) {
        renderedNodes?.update([...uniqueNodes]);
      }
      if (
        typeof renderedEdges?.update === "function" &&
        uniqueEdges?.length > 0
      ) {
        renderedEdges?.update([...uniqueEdges]);
      }
      if (uniqueNodes?.length > 0 || uniqueEdges?.length > 0) {
        if (
          network &&
          network?.redraw &&
          typeof network?.redraw === "function"
        ) {
          network?.redraw();
        }
      }
    } catch (error) {
      console.error(
        "Getting error while updating nodes and edges in case of showHideCommonEdges : ",
        error
      );
    }
  }, [
    showHideCommonEdges,
    showHideMultipleEdges,
    showHideDistinctNodeEdges,
    selectedNode,
    commonEdgesColor,
    edgesHighlightColor,
  ]);
  const loadMoreNetworkData = () => {
    if (
      clustersData &&
      Array.isArray(clustersData) &&
      clustersData?.length > 0 &&
      renderedCluster?.index < clustersData?.length
    ) {
      let newNodes = [],
        newEdges = [];
      let cluster = clustersData?.[renderedCluster?.index];
      let updatedRenderedCluster = { ...renderedCluster };
      if (cluster?.nodes && Array.isArray(cluster?.nodes)) {
        if (
          updatedRenderedCluster?.renderedNodesLength > 0 &&
          updatedRenderedCluster?.renderedNodesLength !== cluster?.nodes?.length
        ) {
          if (
            updatedRenderedCluster?.renderedNodesLength !==
            cluster?.nodes?.length
          ) {
            newNodes = cluster?.nodes?.slice(
              updatedRenderedCluster?.renderedNodesLength,
              updatedRenderedCluster?.renderedNodesLength + NEXT_DATA_SET
            );
            newNodes = getNodeDataForRendering(newNodes);
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedNodesLength:
                updatedRenderedCluster?.renderedNodesLength + NEXT_DATA_SET,
            };
            if (
              updatedRenderedCluster?.renderedNodesLength >=
              cluster?.nodes?.length
            ) {
              updatedRenderedCluster = {
                ...updatedRenderedCluster,
                index: updatedRenderedCluster?.index,
                renderedNodesLength: cluster?.nodes?.length,
              };
            }
          }
        }
      }

      if (cluster?.edges && Array.isArray(cluster?.edges)) {
        if (
          updatedRenderedCluster?.renderedEdgesLength > 0 &&
          updatedRenderedCluster?.renderedEdgesLength !== cluster?.edges?.length
        ) {
          newEdges = cluster?.edges?.slice(
            updatedRenderedCluster?.renderedEdgesLength,
            updatedRenderedCluster?.renderedEdgesLength + NEXT_DATA_SET
          );
          newEdges = getEdgesDataForRendering(newEdges);
          updatedRenderedCluster = {
            ...updatedRenderedCluster,
            index: updatedRenderedCluster?.index,
            renderedEdgesLength:
              updatedRenderedCluster?.renderedEdgesLength + NEXT_DATA_SET,
          };
          if (
            updatedRenderedCluster?.renderedEdgesLength >=
            cluster?.edges?.length
          ) {
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedEdgesLength: cluster?.edges?.length,
            };
          }
        }
      }
      if (
        updatedRenderedCluster?.renderedNodesLength ===
          cluster?.nodes?.length &&
        updatedRenderedCluster?.renderedEdgesLength === cluster?.edges?.length
      ) {
        updatedRenderedCluster = {
          ...updatedRenderedCluster,
          index: updatedRenderedCluster?.index + 1,
          renderedNodesLength: 0,
          renderedEdgesLength: 0,
        };
      } else if (
        updatedRenderedCluster?.renderedNodesLength === 0 &&
        updatedRenderedCluster?.renderedEdgesLength === 0
      ) {
        if (cluster?.nodes && Array.isArray(cluster?.nodes)) {
          if (cluster?.nodeLength > NEXT_DATA_SET) {
            newNodes = cluster?.nodes?.slice(0, NEXT_DATA_SET);
            newNodes = getNodeDataForRendering(newNodes);
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedNodesLength: newNodes?.length,
            };
          } else {
            newNodes = getNodeDataForRendering(cluster?.nodes);
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedNodesLength: newNodes?.length,
            };
          }
        }
        if (cluster?.edges && Array.isArray(cluster?.edges)) {
          if (cluster?.edgesLinkLength > NEXT_DATA_SET) {
            newEdges = cluster?.edges?.slice(0, NEXT_DATA_SET);
            newEdges = getEdgesDataForRendering(newEdges);
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedEdgesLength: newEdges?.length,
            };
          } else {
            newEdges = cluster?.edges;
            newEdges = getEdgesDataForRendering(newEdges);
            updatedRenderedCluster = {
              ...updatedRenderedCluster,
              index: updatedRenderedCluster?.index,
              renderedEdgesLength: newEdges?.length,
            };
          }
        }
        if (
          updatedRenderedCluster?.renderedNodesLength ===
            cluster?.nodes?.length &&
          updatedRenderedCluster?.renderedEdgesLength === cluster?.edges?.length
        ) {
          updatedRenderedCluster = {
            ...updatedRenderedCluster,
            index: updatedRenderedCluster?.index + 1,
            renderedNodesLength: 0,
            renderedEdgesLength: 0,
          };
        }
      }
      setRenderedCluster({
        ...updatedRenderedCluster,
      });
      if (newNodes?.length > 0) {
        // renderedNodes?.add(newNodes);
        renderedNodes?.update([...renderedNodes?.get(), ...newNodes]);
        // setRenderedNodes([...renderedNodes?.get(), ...newNodes]);
        // network?.body?.data?.nodes?.add([...renderedNodes?.get(), ...newNodes]);
      }
      if (newEdges?.length > 0) {
        // renderedEdges?.add(newEdges);
        renderedEdges?.update([...renderedEdges?.get(), ...newEdges]);
        // setRenderedEdges([...renderedEdges?.get(), ...newEdges]);
        // network?.body?.data?.edges?.add(newEdges);
      }
      if (newNodes?.length > 0 || newEdges?.length > 0) {
        // network?.stabilize();
        setProcessNextDataLoad(false);

        if (network && typeof network?.fit === "function") {
          network?.fit();
        }
      }
    }

    // const worker = new Worker(new URL("./networkWorker.js", import.meta.url));
    // worker?.postMessage({
    //   type: "LOAD_MORE_NETWORK_NODES",
    //   currentNodeCount: nodes.length,
    //   additionalNodes: 100,
    //   additionalEdges: 50,
    // });
  };
  // const handleLoadMore = () => {
  //   const worker = new Worker(new URL("./networkWorker.js", import.meta.url));
  //   worker.postMessage({
  //     type: "LOAD_MORE_NODES",
  //     currentNodeCount: nodes.length,
  //     additionalNodes: 100,
  //     additionalEdges: 50,
  //   });

  //   worker.onmessage = function (event) {
  //     const newNodes = event.data.nodes;
  //     const newEdges = event.data.edges;

  //     network.body.data.nodes.add(newNodes);
  //     network.body.data.edges.add(newEdges);
  //     network.stabilize();
  //   };
  // };
  // useEffect(() => {
  //   // console.log(
  //   //   "tooltipObject : ",
  //   //   tooltipObject,
  //   //   "networkDeepDiveObj : ",
  //   //   networkDeepDiveObj
  //   // );
  // }, [tooltipObject, networkDeepDiveObj]);
  const moveNetwork = (direction) => {
    const moveStep = 1000; // Adjust the value for speed of movement
    let moveBy = { x: 0, y: 0 };
    let scaleBy = 1;
    switch (direction) {
      case "zoomIn":
        scaleBy = 1.2;
        break;
      case "zoomOut":
        scaleBy = 0.8;
        break;
      case "down":
        moveBy = { x: 0, y: moveStep };
        break;
      case "up":
        moveBy = { x: 0, y: -moveStep };
        break;
      case "right":
        moveBy = { x: moveStep, y: 0 };
        break;
      case "left":
        moveBy = { x: -moveStep, y: 0 };
        break;

      default:
        break;
    }
    try {
      if (direction === "resetZoom") {
        if (network && typeof network?.fit === "function") {
          network?.fit({
            animation: {
              duration: 200,
              easingFunction: "linear",
            },
          });
        }
      } else if (
        network &&
        typeof network?.moveTo === "function" &&
        typeof network?.getViewPosition === "function" &&
        typeof network?.getScale === "function"
      ) {
        const currentPosition = network?.getViewPosition();
        network?.moveTo({
          scale: network?.getScale() * scaleBy,
          position: {
            x: currentPosition.x + moveBy.x,
            y: currentPosition.y + moveBy.y,
          },
          animation: {
            duration: 200,
            easingFunction: "linear",
          },
        });
      }
    } catch (error) {
      console.error("Error on move chart : ", error);
    }
  };
  const handleMovementStart = (direction) => {
    setDirection(direction);
    moveNetwork(direction);
    if (movementInterval) clearInterval(movementInterval);
    const interval = setInterval(() => moveNetwork(direction), 100);
    setMovementInterval(interval);
  };
  const handleMovementStop = () => {
    setDirection(null);
    if (movementInterval) clearInterval(movementInterval);
  };

  return (
    <>
      <div className="NetworkGraphContainer" style={{ display: "flex" }}>
        {screenLoader ? (
          <div className="Network__Graph w-100 h-100">
            <div
              id={id}
              style={{
                width: style?.width ? style?.width : "100%",
                height:
                  "calc(" +
                  (style?.height
                    ? style?.height?.includes("%")
                      ? style?.height
                      : style?.height?.includes("px")
                      ? style?.height
                      : style?.height + "px"
                    : "45rem") +
                  " - " +
                  (legendDivRef?.current?.clientHeight > 0
                    ? legendDivRef?.current?.clientHeight
                    : 0) +
                  "px)",
              }}
            ></div>
            <div
              style={{
                marginTop: style?.height
                  ? style?.height?.includes("px")
                    ? style?.height
                    : -style?.height + "px"
                  : "-45rem",
                height: style?.height
                  ? style?.height?.includes("px")
                    ? style?.height
                    : style?.height + "px"
                  : "45rem",
              }}
            >
              <div className="loader text-center w-100 h-100">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="Network__Graph w-100 h-100">
              <div
                id={id}
                ref={containerRef}
                style={{
                  width: style?.width ? style?.width : "100%",
                  height:
                    "calc(" +
                    (style?.height
                      ? style?.height?.includes("%")
                        ? style?.height
                        : style?.height?.includes("px")
                        ? style?.height
                        : style?.height + "px"
                      : "45rem") +
                    " - " +
                    (legendDivRef?.current?.clientHeight > 0
                      ? legendDivRef?.current?.clientHeight
                      : 0) +
                    "px)",
                }}
              ></div>
              {!stabilizeNetworkAfterAllNodesRenders ? (
                <GenerateStatus></GenerateStatus>
              ) : (
                ""
              )}
              <div className="Network__legend" ref={measuredLegendRef}>
                {isNetworkDeepDive ? (
                  <div className="Network__legend-item">
                    <div
                      className="Network__legend-piechart"
                      style={{
                        backgroundColor: metadata?.x_axis?.color,
                      }}
                    ></div>
                    <span>{"Posts"} </span>
                  </div>
                ) : (
                  <div className="Network__legend-item">
                    <div
                      className="Network__legend-color"
                      style={{
                        backgroundColor: metadata?.x_axis?.color,
                      }}
                    ></div>
                    <span>{metadata?.x_axis?.trace_name} </span>
                  </div>
                )}

                {metadata?.y_axes && Array.isArray(metadata?.y_axes) ? (
                  <>
                    {metadata?.y_axes?.map((el, i) => {
                      return (
                        <>
                          <div className="Network__legend-item">
                            <div
                              className="Network__legend-color"
                              style={{
                                backgroundColor: el?.color,
                              }}
                            ></div>
                            <span>{el?.trace_name}</span>
                          </div>
                        </>
                      );
                    })}
                  </>
                ) : (
                  ""
                )}

                <div className="Network__legend-item">
                  <div
                    className="Network__legend-color"
                    style={{
                      backgroundColor: commonEdgesColor,
                    }}
                  ></div>
                  <span>Common Edge</span>
                </div>
                <div className="Network__legend-item">
                  <div
                    className="Network__legend-color"
                    style={{
                      backgroundColor: edgesHighlightColor,
                    }}
                  ></div>
                  <span>Selected Mode</span>
                </div>
              </div>
              {/* <Button
            onClick={handleFullScreen}
            className="fullScreen--btn btn_Clear m-1"
          >
            Full Screen
          </Button> */}
              {/* {postCardDetails && (
            <>
              <NetworkNodeModal
                modalData={postCardDetails}
                isModalOpen={postCardDetails ? true : false}
                setIsModalOpen={setIsModalOpen}
                setIsModalData={setPostCardDetails}
                isVisNetworkGraph={true}
                isModalLoader={isModalLoader}
                setIsModalLoader={setIsModalLoader}
              />
            </>
          )} */}
              {networkDeepDiveObj ? (
                <>
                  <NetworkDeepdive
                    networkDeepDiveObj={networkDeepDiveObj}
                    isNetworkModalOpen={networkDeepDiveObj ? true : false}
                    setIsNetworkModalOpen={setIsNetworkModalOpen}
                    setNetworkDeepDiveObj={setNetworkDeepDiveObj}
                    isVisNetworkGraph={true}
                    isModalLoader={isModalLoader}
                    setIsModalLoader={setIsModalLoader}
                    section_index={section_index}
                    widget_index={widget_index}
                    metadata={metadata}
                    style={style}
                    id={id}
                    PdfDownloadStatus={PdfDownloadStatus}
                    type={type}
                    dashboard={dashboard}
                  />
                </>
              ) : (
                ""
              )}
              {tooltipObject ? (
                <NetworkNodeTooltip
                  tooltipData={tooltipObject}
                  isTooltipShow={tooltipObject === null ? false : true}
                  containerRef={containerRef}
                  dashboard={dashboard}
                />
              ) : (
                ""
              )}

              {/* <div
            className={`wordcloud_card ${
              tooltipObject === null ? "d-none" : ""
            }`}
            style={{
              left: tooltipObject?.clientX,
              top: tooltipObject?.clientY,
              width: "20rem",
              height: "20rem",
              backgroundColor: tooltipObject?.node?.color?.background,
              borderColor: tooltipObject?.node?.color?.color,
            }}
          >
            Tooltip AuthorBio
          </div> */}
            </div>
            {/* Sidebar for custom navigation */}
            <div className="Network__Sidebar border-color border-top">
              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "reset" ? "active" : ""
                }`}
                src={
                  authParams?.theme_type === "1" ? FullScreen : FullScreenDark
                }
                onClick={() => {
                  if (network && typeof network?.stabilize === "function") {
                    network?.stabilize();
                  }
                }}
              />
              <span className="Network__Sidebar--sep border-color"></span> */}
              {isNetworkDeepDive && !hideSetting ? (
                <>
                  <Popover
                    open={settingPopoverOpen}
                    onOpenChange={(value) => {
                      if (!value) {
                        setAxisSettingData(null);
                        setAxisNodeLimitData(null);
                      }
                      setSettingPopoverOpen(value);
                    }}
                    overlayClassName={`Network__Setting--popover ${
                      authParams?.theme_type === "1"
                        ? "darkTheme"
                        : "lightTheme"
                    }`}
                    trigger={"click"}
                    placement="bottomRight"
                    title={null}
                    content={
                      <div className="Network__Setting">
                        <div className="Network__Setting--wrap">
                          {metadata?.y_axes &&
                          Array.isArray(metadata?.y_axes) ? (
                            <>
                              {metadata?.y_axes?.map((el, i) => {
                                return (
                                  <>
                                    <div className="Network__Setting--title">
                                      {el?.trace_name}{" "}
                                    </div>
                                    <div className="Network__Setting--number d-flex">
                                      <div className="Network__Setting--div d-flex flex-direction-row">
                                        <div className="Network__Setting--div d-flex flex-direction-column mb-15">
                                          <div
                                            className="floating-label-group"
                                            style={{ flexGrow: "0.5" }}
                                          >
                                            <input
                                              type="number"
                                              id={`number_of_words_y_axes_${i}`}
                                              className="Network__Setting--numInput"
                                              min={minimumYAxesNodesLimit}
                                              max={maximumYAxesNodesLimit}
                                              value={
                                                axisNodeLimitData?.y_axes?.[i]
                                                  ?.y_limit
                                              }
                                              onChange={(e) => {
                                                if (e?.target) {
                                                  e.target.value =
                                                    e?.target?.value?.replace(
                                                      /^0/,
                                                      ""
                                                    );
                                                }
                                                handleChangeNodeLimit(
                                                  e?.target?.value,
                                                  "y_axes",
                                                  i
                                                );
                                              }}
                                            />
                                            <label
                                              className="portlet-label floating-label bg__white font-size12"
                                              style={{ top: "-0.8rem" }}
                                              for={`number_of_words_y_axes_${i}`}
                                            >
                                              Number of nodes
                                            </label>
                                          </div>
                                          <div
                                            className={`Screen__defaultMessage ${
                                              (axisNodeLimitData?.y_axes?.[i]
                                                ?.y_limit
                                                ? axisNodeLimitData?.y_axes?.[i]
                                                    ?.y_limit
                                                : 0) >=
                                                minimumYAxesNodesLimit &&
                                              (axisNodeLimitData?.y_axes?.[i]
                                                ?.y_limit
                                                ? axisNodeLimitData?.y_axes?.[i]
                                                    ?.y_limit
                                                : 0) <= maximumYAxesNodesLimit
                                                ? ""
                                                : "Screen__errorMessage"
                                            }`}
                                          >
                                            {`Enter a number between ${minimumYAxesNodesLimit} and ${maximumYAxesNodesLimit}.`}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="Network__Setting--footer">
                          <Button
                            disabled={!settingAppliedStatus}
                            onClick={() => handleSettingApplied()}
                            className="ant-btn-primary_blue"
                            type="primary"
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    }
                  >
                    <Tooltip title={"Settings"} placement="left">
                      {/* <img
                        className={`Network__Sidebar--btn ${
                          settingPopoverOpen ? "active" : ""
                        }`}
                        src={
                          authParams?.theme_type === "1"
                            ? SeetingIconDark
                            : SeetingIconWhite
                        }
                      /> */}
                      <span
                        className={`Network__Sidebar--btn ${
                          settingPopoverOpen ? "active" : ""
                        }`}
                      >
                        {getNetworkIcon(
                          "Setting",
                          isPersonalizationPreviewOpen
                        )}
                      </span>
                    </Tooltip>
                  </Popover>

                  <span className="Network__Sidebar--sep border-color"></span>
                </>
              ) : (
                ""
              )}

              <Tooltip title={"Reset Zoom"} placement="left">
                {/* <img
                  className={`Network__Sidebar--btn ${
                    direction === "resetZoom" ? "active" : ""
                  }`}
                  src={
                    authParams?.theme_type === "1"
                      ? RefershIconDark
                      : RefershIcon
                  }
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("resetZoom")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                /> */}
                <span
                  className={`Network__Sidebar--btn ${
                    direction === "resetZoom" ? "active" : ""
                  }`}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("resetZoom")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                >
                  {getNetworkIcon("Refresh", isPersonalizationPreviewOpen)}
                </span>
              </Tooltip>

              <span className="Network__Sidebar--sep border-color"></span>
              <Tooltip title={"Zoom In"} placement="left">
                {/* <img
                  className={`Network__Sidebar--btn ${
                    direction === "zoomIn" ? "active" : ""
                  }`}
                  src={authParams?.theme_type === "1" ? ZoomInDark : ZoomIn}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("zoomIn")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                /> */}
                <span
                  className={`Network__Sidebar--btn ${
                    direction === "zoomIn" ? "active" : ""
                  }`}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("zoomIn")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                >
                  {getNetworkIcon("ZoomIn", isPersonalizationPreviewOpen)}
                </span>
              </Tooltip>
              <Tooltip title={"Zoom Out"} placement="left">
                {/* <img
                  className={`Network__Sidebar--btn ${
                    direction === "zoomOut" ? "active" : ""
                  }`}
                  src={authParams?.theme_type === "1" ? ZoomOutDark : ZoomOut}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("zoomOut")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                /> */}
                <span
                  className={`Network__Sidebar--btn ${
                    direction === "zoomOut" ? "active" : ""
                  }`}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => handleMovementStart("zoomOut")}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                >
                  {getNetworkIcon("ZoomOut", isPersonalizationPreviewOpen)}
                </span>
              </Tooltip>

              <span className="Network__Sidebar--sep border-color"></span>

              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "up" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowUpDark : ArrowUp}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("up")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              /> */}
              <span
                className={`Network__Sidebar--btn ${
                  direction === "up" ? "active" : ""
                }`}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("up")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              >
                {getNetworkIcon("ArrowUp", isPersonalizationPreviewOpen)}
              </span>
              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "left" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowLeftDark : ArrowLeft}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("left")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              /> */}
              <span
                className={`Network__Sidebar--btn ${
                  direction === "left" ? "active" : ""
                }`}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("left")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              >
                {getNetworkIcon("ArrowLeft", isPersonalizationPreviewOpen)}
              </span>
              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "down" ? "active" : ""
                }`}
                src={authParams?.theme_type === "1" ? ArrowDownDark : ArrowDown}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("down")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              /> */}
              <span
                className={`Network__Sidebar--btn ${
                  direction === "down" ? "active" : ""
                }`}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("down")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              >
                {getNetworkIcon("ArrowDown", isPersonalizationPreviewOpen)}
              </span>
              {/* <img
                className={`Network__Sidebar--btn ${
                  direction === "right" ? "active" : ""
                }`}
                src={
                  authParams?.theme_type === "1" ? ArrowRightDark : ArrowRight
                }
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("right")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              /> */}
              <span
                className={`Network__Sidebar--btn ${
                  direction === "right" ? "active" : ""
                }`}
                onMouseEnter={handleMovementStop}
                onMouseDown={() => handleMovementStart("right")}
                onMouseUp={handleMovementStop}
                onMouseLeave={handleMovementStop}
              >
                {getNetworkIcon("ArrowRight", isPersonalizationPreviewOpen)}
              </span>
              <span className="Network__Sidebar--sep border-color"></span>
              <Tooltip
                title={
                  showHideCommonEdges
                    ? "Unhide Common Nodes and Links"
                    : "Hide Common Nodes and Links"
                }
                placement="left"
              >
                {/* <img
                  className={`Network__Sidebar--btn ${
                    direction === "commonEdges" ? "active" : ""
                  }`}
                  src={
                    authParams?.theme_type === "1"
                      ? showHideCommonEdges
                        ? UnhideNodesDark
                        : HideNodesDark
                      : showHideCommonEdges
                      ? UnhideNodes
                      : HideNodes
                  }
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => {
                    setShowHideCommonEdges(!showHideCommonEdges);
                    handleMovementStart("commonEdges");
                  }}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                /> */}
                <span
                  className={`Network__Sidebar--btn ${
                    direction === "commonEdges" ? "active" : ""
                  }`}
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => {
                    setShowHideCommonEdges(!showHideCommonEdges);
                    handleMovementStart("commonEdges");
                  }}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                >
                  {getNetworkIcon(
                    showHideCommonEdges ? "UnhideNodes" : "HideNodes",
                    isPersonalizationPreviewOpen
                  )}
                </span>
              </Tooltip>
              {!isNetworkDeepDive ? (
                <Tooltip
                  title={
                    showHideMultipleEdges
                      ? "Show Multiple Relations"
                      : "Hide Multiple Relations"
                  }
                  placement="left"
                >
                  {/* <img
                    className={`Network__Sidebar--btn ${
                      direction === "multipleEdges" ? "active" : ""
                    }`}
                    src={
                      authParams?.theme_type === "1"
                        ? showHideMultipleEdges
                          ? UnhideMultilneDark
                          : HideMultilneDark
                        : showHideMultipleEdges
                        ? UnhideMultilne
                        : HideMultilne
                    }
                    onMouseEnter={handleMovementStop}
                    onMouseDown={() => {
                      setShowHideMultipleEdges(!showHideMultipleEdges);
                      handleMovementStart("multipleEdges");
                    }}
                    onMouseUp={handleMovementStop}
                    onMouseLeave={handleMovementStop}
                  /> */}
                  <span
                    className={`Network__Sidebar--btn ${
                      direction === "multipleEdges" ? "active" : ""
                    }`}
                    onMouseEnter={handleMovementStop}
                    onMouseDown={() => {
                      setShowHideMultipleEdges(!showHideMultipleEdges);
                      handleMovementStart("multipleEdges");
                    }}
                    onMouseUp={handleMovementStop}
                    onMouseLeave={handleMovementStop}
                  >
                    {getNetworkIcon(
                      showHideMultipleEdges ? "UnhideMultilne" : "HideMultilne",
                      isPersonalizationPreviewOpen
                    )}{" "}
                  </span>
                </Tooltip>
              ) : (
                ""
              )}

              {/* <Tooltip
                title={showHideDistinctNodeEdges ? "Unhide" : "Hide"}
                placement="left"
              >
                <img
                  className={`Network__Sidebar--btn ${
                    direction === "right" ? "active" : ""
                  }`}
                  src={
                    authParams?.theme_type === "1"
                      ? showHideDistinctNodeEdges
                        ? UnhideDistinctNodesDark
                        : HideDistinctNodesDark
                      : showHideDistinctNodeEdges
                      ? UnhideDistinctNodes
                      : HideDistinctNodes
                  }
                  onMouseEnter={handleMovementStop}
                  onMouseDown={() => {
                    setShowHideDistinctNodeEdges(!showHideDistinctNodeEdges);
                  }}
                  onMouseUp={handleMovementStop}
                  onMouseLeave={handleMovementStop}
                />
              </Tooltip> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default React?.memo(NetworkClusterV2, isEqual);
